module.exports = __webpack_public_path__ + "img/gift_boxdidi.441098a5.png";